<template>
    <div class="md-layout text-center">
        <div class="md-layout-item md-size-50 md-small-size-100">
        <b>Testing page.</b>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        name: 'Testbed',
        mounted() {
            this.run_test();
            // Do something else.
        },
        components: {
            
        },
        data() {
            return {
                test: 1/0
            };
        },

        methods: {
            run_test() {
                //console.log("running test...");//

                axios.get(
                    process.env.VUE_APP_API_BASE_URL + "/info/general?info_idss=title_codes",
                    {},
                    {
                        /*params: {
                            session_id: this.currentSession,
                            info_ids: "title_codes"
                        },*/
                    }
                )
                /*.then((res) => {
                    if (res.hasOwnProperty("data") && res.data.error) {
                        this.$store.commit("SET_ERROR_BIT", true);
                        this.$store.commit(
                            "SET_ERROR_INFO",
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/conference/ibba2022/impersonate" <br>`
                        );
                        throw new Error(
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode
                        );
                    }
                });*/
                ;
            }
        }
    };
</script>
<style></style>